import React, { useEffect, useState } from 'react';
import { Popup } from '@fluentui/react';
import { CloseIcon } from '../../assets'
import styles from './QuickPrompts.module.css'; // your CSS module
import quickPrompts from '../../assets/data/quick-prompts.json'; // Adjust the path as necessary

interface QuickPromptsProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (text: string) => void;
}

interface PromptDataItem {
  id: string;
  category: string;
  text: string;
}

const QuickPrompts = ({ isOpen, onClose, onSelect }: QuickPromptsProps) => {
  const [promptData, setPromptData] = useState<PromptDataItem[]>([]);
  useEffect(() => {
    if (isOpen) {
      if (!Array.isArray(quickPrompts)) {
        console.error('quick-prompts.json is missing items array');
      }
      else {
        const data = quickPrompts as PromptDataItem[];
        setPromptData(data)
      }
    }
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <>
      <div className={styles.backdrop} onClick={onClose}></div>
      <Popup className={styles.clearPopup} onDismiss={onClose}>
        <div className={styles.popupContainer}>
          <div className={styles.popupHeader}>
            <span className={styles.popupTitle}>Quick Prompts</span>
            <span
              className={styles.popupCloseButton}
              role="button"
              tabIndex={0}
              onClick={onClose}
              aria-label="Close"
            >
              <img src={CloseIcon} alt="" />
            </span>
          </div>
          <div className={styles.popupContent}>
            {promptData.map(prompt => (
              <div
                key={prompt.id}
                className={styles.promptCard}
                onClick={() => {
                  onSelect(prompt.text);
                  onClose();
                }}
              >
                <label className={styles.promptDataCategory}>{prompt.category}</label>
                <p className={styles.promptDataText}>{prompt.text}</p>
              </div>
            ))}
          </div>
        </div>
      </Popup>
    </>
  );
};

export default QuickPrompts;
